<script setup lang="ts">
import Step1 from './steps/Step1.vue';
import Step2 from './steps/Step2.vue';
import Step3 from './steps/Step3.vue';

interface SharingStep {
  title: string;
  desc: string;
  tab: 'preview' | 'templates';
  showOverlay?: boolean;
}

const props = defineProps<{
  activeStep: number;
  steps: SharingStep[];
  selectedTemplate: number;
  templates: Array<{ name: string; bg: string; accent: string; logo: string; image?: string }>;
}>();

const emit = defineEmits(['select-template', 'update:activeStep']);
</script>

<template>
  <div class="app-mock-container share-mock-bg-prod dark">
    <transition name="fade-in" mode="out-in">
      <Step1 
        v-if="activeStep === 0" 
        :activeStep="activeStep" 
        :steps="steps" 
        @update:activeStep="emit('update:activeStep', $event)" 
      />
      <Step2
        v-else-if="activeStep === 1"
        :activeStep="activeStep"
        :steps="steps"
        :selectedTemplate="selectedTemplate"
        :templates="templates"
        @select-template="emit('select-template', $event)"
        @update:activeStep="emit('update:activeStep', $event)"
      />
      <Step3
        v-else-if="activeStep === 2"
        :activeStep="activeStep"
        :steps="steps"
        @update:activeStep="emit('update:activeStep', $event)"
      />
    </transition>
  </div>
</template>

<style scoped>
.app-mock-container {
  width: 100%;
  max-width: 800px;
  height: 600px;
  background: #09090b;
  border-radius: 32px;
  border: 1px solid rgba(255,255,255,0.1);
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.fade-in-enter-active { animation: fadeIn 0.4s ease; }
.fade-in-leave-active { animation: fadeOut 0.3s ease; }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes fadeOut { from { opacity: 1; } to { opacity: 0; } }
</style>
